<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group [title]="'wbo.price-level.edit.formation.details'" [formControlNames]="''">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name"
                                               [(ngModel)]="model.data.name"></wbo-text-edit-control>
                        <fui-column [label]="'wbo.price-level.edit.field-set.defaultPricing'">
                            <wbo-price-level-single-select-edit-control formControlName="basePriceLevelId"
                                                                        [excludePriceLevelId]="model.data.priceLevelId"
                                                                        [(ngModel)]="model.data.basePriceLevelId"></wbo-price-level-single-select-edit-control>
                            <ng-container formGroupName="modifier">
                                <wbo-single-select-edit-control formControlName="type"
                                                                [(ngModel)]="model.data.modifier.type"
                                                                [allowClearSelectionOption]="false"
                                                                [overrideRequired]="!!model.data.basePriceLevelId">
                                    <wbo-select-options>
                                        <wbo-select-option [value]="Markup_Type.NONE" label="wbo.price-level.edit.option.markupType.none">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="Markup_Type.FIXED_MARKUP" label="wbo.price-level.edit.option.markupType.fixedMarkup">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="Markup_Type.PERCENT_MARKUP" label="wbo.price-level.edit.option.markupType.percentMarkup">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="Markup_Type.FIXED_MARKDOWN" label="wbo.price-level.edit.option.markupType.fixedMarkdown">
                                        </wbo-select-option>
                                        <wbo-select-option [value]="Markup_Type.PERCENT_MARKDOWN" label="wbo.price-level.edit.option.markupType.percentMarkdown">
                                        </wbo-select-option>
                                    </wbo-select-options>
                                </wbo-single-select-edit-control>
                            </ng-container>
                            <fui-tandem-field formGroupName="modifier">
                                <ng-container>
                                    <wbo-numeric-edit-control formControlName="value"
                                                              [(ngModel)]="model.data.modifier.value"
                                                              [decimals]="2" [notation]="getMarkupNotation() | translate"
                                                              [overrideRequired]="!!model.data.basePriceLevelId || !!model.data.modifier.type"
                                                              [readonly]="!model.data.basePriceLevelId && !model.data.modifier.type"></wbo-numeric-edit-control>
                                </ng-container>
                                <fui-column>
                                    <wbo-checkbox-edit-control formControlName="roundingApplied"
                                                               [(ngModel)]="model.data.modifier.roundingApplied"
                                                               [readonly]="!model.data.basePriceLevelId && !model.data.modifier.type"></wbo-checkbox-edit-control>
                                </fui-column>
                            </fui-tandem-field>
                        </fui-column>
                    </fui-column>
                    <fui-column>
                        <wbo-text-edit-control formControlName="priority"
                                               [(ngModel)]="model.data.priority"></wbo-text-edit-control>
                        <fui-column [label]="'wbo.price-level.edit.field-set.usage'"
                                    formGroupName="posRestrictions">
                            <fui-tandem-field>
                                <wbo-checkbox-edit-control formControlName="manualOverride"
                                                           [(ngModel)]="model.data.posRestrictions.manualOverride"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control formControlName="schedule"
                                                           [(ngModel)]="model.data.posRestrictions.schedule"></wbo-checkbox-edit-control>
                            </fui-tandem-field>
                            <fui-tandem-field>
                                <wbo-checkbox-edit-control formControlName="membershipType"
                                                           [(ngModel)]="model.data.posRestrictions.membershipType"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control formControlName="account"
                                                           [(ngModel)]="model.data.posRestrictions.account"></wbo-checkbox-edit-control>
                            </fui-tandem-field>
                            <fui-tandem-field>
                                <wbo-checkbox-edit-control formControlName="member"
                                                           [(ngModel)]="model.data.posRestrictions.member"></wbo-checkbox-edit-control>
                                <wbo-checkbox-edit-control formControlName="webTerminal"
                                                           [(ngModel)]="model.data.posRestrictions.webTerminal"></wbo-checkbox-edit-control>
                            </fui-tandem-field>
                        </fui-column>
                        <wbo-period-schedule-multi-select-edit-control formControlName="periodSchedules"
                                                                       [multiObjectValueType]="true"
                                                                       [(ngModel)]="model.data.periodSchedules"></wbo-period-schedule-multi-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group>
    <ng-container *ngIf="editPage.editMode !== EditMode.ADD">
        <fui-formation-group-template
            *formationGroup="{title: 'wbo.price-level.edit.formation.schedules', formControlNames: 'schedules'}">
            <wbo-edit-grid [data]="model.data.schedules"
                           [editable]="true"
                           [removable]="true"
                           [customRemovable]="true"
                           [rowRemovable]="scheduleRowRemovable"
                           (customRemoving)="discontinueSchedule($event)"
                           [entityPath]="'schedules'">
                <wbo-edit-link-column field="name" [showDiscontinued]="true"
                                      [editComponent]="PriceLevelScheduleEditPageComponent"
                                      [parentEntity]="model.data"></wbo-edit-link-column>
                <wbo-translated-column [title]="'wbo.pricing.schedule.column.description'"
                                       [messageRetriever]="PricingScheduleSummaryData.getDescriptionMessage"></wbo-translated-column>
                <wbo-edit-grid-add-row [identifierField]="'priceLevelScheduleId'">
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-new-entity
                            [editComponent]="PriceLevelScheduleEditPageComponent"
                            [parentEntity]="model.data"></wbo-edit-grid-add-row-new-entity>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-formation-group-template>
    </ng-container>
</wbo-edit-page>
